import React from "react";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  position?: "center" | "right"; 
  className?: string;
}

export const Modal = ({
  open,
  onClose,
  children,
  position = "center",
  className = "",
}: ModalProps) => {
  return (
    <div
      className={`fixed !m-0 inset-0 z-50 flex ${
        position === "right" ? "justify-end" : "items-center justify-center"
      } transition-all duration-300 ${
        open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
      }`}
      aria-modal="true"
      role="dialog"
    >
      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-black/40 transition-opacity duration-300 ${
          open ? "opacity-100" : "opacity-0"
        }`}
        onClick={onClose}
      />
      {/* Modal content */}
      <div
        className={`relative ${
          position === "right"
            ? "w-full max-w-md h-full rounded-none"
            : "w-full max-w-md rounded-xl"
        } bg-brand-surface shadow-xl overflow-y-auto transition-all duration-300
        ${
          open
            ? position === "right"
              ? "translate-x-0 opacity-100"
              : "scale-100 opacity-100"
            : position === "right"
              ? "translate-x-full opacity-0"
              : "scale-95 opacity-0"
        }
        ${className}
        `}
      >
        {children}
      </div>
    </div>
  );
};